//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Geeft de beschikbare AOV's.
     * @return OK
     */
    aovsOphalen(): Promise<AovBasisOutput> {
        let url_ = this.baseUrl + "/Aov";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAovsOphalen(_response);
        });
    }

    protected processAovsOphalen(response: Response): Promise<AovBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AovBasisOutput;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AovBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AovBasisOutput>(null as any);
    }

    /**
     * Geeft de beschikbare AOV's van een verzekeringsmaatschappij met behulp van de code.
     * @param maatschappijCode Code van de verzekeringsmaatschappij zoals deze in de Adviesbox producten-database is gedefinieerd
     * @return OK
     */
    aovsMetVerzekeringsmaatschappijCodeOphalen(maatschappijCode: string): Promise<AovBasisOutput> {
        let url_ = this.baseUrl + "/MaatschappijCodes/{maatschappijCode}/Aov";
        if (maatschappijCode === undefined || maatschappijCode === null)
            throw new Error("The parameter 'maatschappijCode' must be defined.");
        url_ = url_.replace("{maatschappijCode}", encodeURIComponent("" + maatschappijCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAovsMetVerzekeringsmaatschappijCodeOphalen(_response);
        });
    }

    protected processAovsMetVerzekeringsmaatschappijCodeOphalen(response: Response): Promise<AovBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AovBasisOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AovBasisOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AovBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AovBasisOutput>(null as any);
    }

    /**
     * Geeft de beschikbare AOV's van een verzekeringsmaatschappij met behulp van de ID.
     * @param maatschappijId ID van de verzekeringsmaatschappij
     * @return OK
     */
    aovsMetVerzekeringsmaatschappijIdOphalen(maatschappijId: string): Promise<AovBasisOutput> {
        let url_ = this.baseUrl + "/Maatschappijen/{maatschappijId}/Aov";
        if (maatschappijId === undefined || maatschappijId === null)
            throw new Error("The parameter 'maatschappijId' must be defined.");
        url_ = url_.replace("{maatschappijId}", encodeURIComponent("" + maatschappijId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAovsMetVerzekeringsmaatschappijIdOphalen(_response);
        });
    }

    protected processAovsMetVerzekeringsmaatschappijIdOphalen(response: Response): Promise<AovBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AovBasisOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AovBasisOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AovBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AovBasisOutput>(null as any);
    }

    /**
     * Geeft de kenmerken van een AOV met behulp van de code (maatschappij en product).
     * @param maatschappijCode Code van de verzekeringsmaatschappij zoals deze in de Adviesbox producten-database is gedefinieerd
     * @param productCode Code van de AOV zoals deze in de Adviesbox producten-database is gedefinieerd
     * @return OK
     */
    productkenmerkenAovMetCodeOphalen(maatschappijCode: string, productCode: number): Promise<ProductkenmerkenOutput> {
        let url_ = this.baseUrl + "/MaatschappijCodes/{maatschappijCode}/Aov/{productCode}/Productkenmerken";
        if (maatschappijCode === undefined || maatschappijCode === null)
            throw new Error("The parameter 'maatschappijCode' must be defined.");
        url_ = url_.replace("{maatschappijCode}", encodeURIComponent("" + maatschappijCode));
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductkenmerkenAovMetCodeOphalen(_response);
        });
    }

    protected processProductkenmerkenAovMetCodeOphalen(response: Response): Promise<ProductkenmerkenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductkenmerkenOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductkenmerkenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductkenmerkenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductkenmerkenOutput>(null as any);
    }

    /**
     * Geeft de beschikbare bankgarantieinstellingen.
     * @return OK
     */
    bankgarantieinstellingenOphalen(): Promise<MaatschappijenDetailsOutput> {
        let url_ = this.baseUrl + "/Bankgarantieinstellingen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBankgarantieinstellingenOphalen(_response);
        });
    }

    protected processBankgarantieinstellingenOphalen(response: Response): Promise<MaatschappijenDetailsOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaatschappijenDetailsOutput;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaatschappijenDetailsOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaatschappijenDetailsOutput>(null as any);
    }

    /**
     * Geeft de kenmerken van een bankgarantieinstelling met behulp van een maatschappijcode
     * @param maatschappijCode Maatschappijcode
     * @return OK
     */
    productkenmerkenBankgarantieinstellingOphalen(maatschappijCode: string): Promise<ProductkenmerkenOutput> {
        let url_ = this.baseUrl + "/Maatschappijcodes/{maatschappijCode}/Bankgarantieinstellingen/Productkenmerken";
        if (maatschappijCode === undefined || maatschappijCode === null)
            throw new Error("The parameter 'maatschappijCode' must be defined.");
        url_ = url_.replace("{maatschappijCode}", encodeURIComponent("" + maatschappijCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductkenmerkenBankgarantieinstellingOphalen(_response);
        });
    }

    protected processProductkenmerkenBankgarantieinstellingOphalen(response: Response): Promise<ProductkenmerkenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductkenmerkenOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductkenmerkenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductkenmerkenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductkenmerkenOutput>(null as any);
    }

    /**
     * Geeft de beschikbare fondsen.
     * @return OK
     */
    fondsenOphalen(): Promise<FondsenOutput> {
        let url_ = this.baseUrl + "/Fondsen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFondsenOphalen(_response);
        });
    }

    protected processFondsenOphalen(response: Response): Promise<FondsenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FondsenOutput;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FondsenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FondsenOutput>(null as any);
    }

    /**
     * Geeft de beschikbare fondsen van een maatschappij met behulp van de code.
     * @param maatschappijCode Code van de maatschappij zoals deze in de Adviesbox producten-database is gedefinieerd
     * @return OK
     */
    fondsenMetMaatschappijCodeOphalen(maatschappijCode: string): Promise<FondsenOutput> {
        let url_ = this.baseUrl + "/MaatschappijCodes/{maatschappijCode}/Fondsen";
        if (maatschappijCode === undefined || maatschappijCode === null)
            throw new Error("The parameter 'maatschappijCode' must be defined.");
        url_ = url_.replace("{maatschappijCode}", encodeURIComponent("" + maatschappijCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFondsenMetMaatschappijCodeOphalen(_response);
        });
    }

    protected processFondsenMetMaatschappijCodeOphalen(response: Response): Promise<FondsenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FondsenOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FondsenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FondsenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FondsenOutput>(null as any);
    }

    /**
     * Geeft de beschikbare fondsen van een maatschappij met behulp van de ID.
     * @param maatschappijId ID van de maatschappij
     * @return OK
     */
    fondsenMetMaatschappijIdOphalen(maatschappijId: string): Promise<FondsenOutput> {
        let url_ = this.baseUrl + "/Maatschappijen/{maatschappijId}/Fondsen";
        if (maatschappijId === undefined || maatschappijId === null)
            throw new Error("The parameter 'maatschappijId' must be defined.");
        url_ = url_.replace("{maatschappijId}", encodeURIComponent("" + maatschappijId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFondsenMetMaatschappijIdOphalen(_response);
        });
    }

    protected processFondsenMetMaatschappijIdOphalen(response: Response): Promise<FondsenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FondsenOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FondsenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FondsenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FondsenOutput>(null as any);
    }

    /**
     * Geeft de beschikbare geldverstrekkers.
     * @return OK
     */
    geldverstrekkersOphalen(): Promise<MaatschappijenDetailsOutput> {
        let url_ = this.baseUrl + "/Geldverstrekkers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGeldverstrekkersOphalen(_response);
        });
    }

    protected processGeldverstrekkersOphalen(response: Response): Promise<MaatschappijenDetailsOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaatschappijenDetailsOutput;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaatschappijenDetailsOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaatschappijenDetailsOutput>(null as any);
    }

    /**
     * Geeft de beschikbare hypotheeklabels.
     * @return OK
     */
    hypotheeklabelsOphalen(): Promise<ProductenBasisOutput> {
        let url_ = this.baseUrl + "/Hypotheeklabels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheeklabelsOphalen(_response);
        });
    }

    protected processHypotheeklabelsOphalen(response: Response): Promise<ProductenBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenBasisOutput;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductenBasisOutput>(null as any);
    }

    /**
     * Geeft de beschikbare hypotheeklabels inclusief hypotheekopties.
     * @param inclGeenAankoop (optional) Indicatie dat labels waar geen aankoop mogelijk is teruggegeven moeten worden
     * @param maatschappijCode (optional) Maatschappijcode van de maatschappij waarvan ook de labels waar geen aankoop mogelijk is teruggegeven moeten worden
     * @param maatschappijCodesDoorlopend (optional) Comma-gescheiden lijst met maatschappijcodes van doorlopende leningdelen t.b.v. de bepaling of een meeneemhypotheek mogelijk is
     * @return OK
     */
    hypotheeklabelsMetHypotheekoptiesOphalen(inclGeenAankoop: boolean | null | undefined, maatschappijCode: string | null | undefined, maatschappijCodesDoorlopend: string | null | undefined): Promise<HypotheeklabelMetHypotheekoptiesOutput> {
        let url_ = this.baseUrl + "/Hypotheeklabels/MetHypotheekopties?";
        if (inclGeenAankoop !== undefined && inclGeenAankoop !== null)
            url_ += "inclGeenAankoop=" + encodeURIComponent("" + inclGeenAankoop) + "&";
        if (maatschappijCode !== undefined && maatschappijCode !== null)
            url_ += "maatschappijCode=" + encodeURIComponent("" + maatschappijCode) + "&";
        if (maatschappijCodesDoorlopend !== undefined && maatschappijCodesDoorlopend !== null)
            url_ += "maatschappijCodesDoorlopend=" + encodeURIComponent("" + maatschappijCodesDoorlopend) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheeklabelsMetHypotheekoptiesOphalen(_response);
        });
    }

    protected processHypotheeklabelsMetHypotheekoptiesOphalen(response: Response): Promise<HypotheeklabelMetHypotheekoptiesOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheeklabelMetHypotheekoptiesOutput;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheeklabelMetHypotheekoptiesOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HypotheeklabelMetHypotheekoptiesOutput>(null as any);
    }

    /**
     * Geeft de beschikbare hypotheeklabels van een geldverstrekker met behulp van de code.
     * @param maatschappijCode Code van de geldverstrekker zoals deze in de Adviesbox producten-database is gedefinieerd
     * @return OK
     */
    hypotheeklabelsMetGeldverstrekkerCodeOphalen(maatschappijCode: string): Promise<ProductenBasisOutput> {
        let url_ = this.baseUrl + "/MaatschappijCodes/{maatschappijCode}/Hypotheeklabels";
        if (maatschappijCode === undefined || maatschappijCode === null)
            throw new Error("The parameter 'maatschappijCode' must be defined.");
        url_ = url_.replace("{maatschappijCode}", encodeURIComponent("" + maatschappijCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheeklabelsMetGeldverstrekkerCodeOphalen(_response);
        });
    }

    protected processHypotheeklabelsMetGeldverstrekkerCodeOphalen(response: Response): Promise<ProductenBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenBasisOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenBasisOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductenBasisOutput>(null as any);
    }

    /**
     * Geeft de gedetailleerde informatie over het hypotheeklabel met behulp van de code.
     * @param maatschappijCode Code van de geldverstrekker zoals deze in de Adviesbox producten-database is gedefinieerd
     * @param hypotheeklabelCode Code van het hypotheeklabel zoals deze in de Adviesbox producten-database is gedefinieerd
     * @return OK
     */
    detailsVanHypotheeklabelMetCodeOphalen(maatschappijCode: string, hypotheeklabelCode: number): Promise<HypotheeklabelDetailsOutput> {
        let url_ = this.baseUrl + "/MaatschappijCodes/{maatschappijCode}/Hypotheeklabels/{hypotheeklabelCode}/Details";
        if (maatschappijCode === undefined || maatschappijCode === null)
            throw new Error("The parameter 'maatschappijCode' must be defined.");
        url_ = url_.replace("{maatschappijCode}", encodeURIComponent("" + maatschappijCode));
        if (hypotheeklabelCode === undefined || hypotheeklabelCode === null)
            throw new Error("The parameter 'hypotheeklabelCode' must be defined.");
        url_ = url_.replace("{hypotheeklabelCode}", encodeURIComponent("" + hypotheeklabelCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDetailsVanHypotheeklabelMetCodeOphalen(_response);
        });
    }

    protected processDetailsVanHypotheeklabelMetCodeOphalen(response: Response): Promise<HypotheeklabelDetailsOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheeklabelDetailsOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheeklabelDetailsOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheeklabelDetailsOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HypotheeklabelDetailsOutput>(null as any);
    }

    /**
     * Geeft de beschikbare hypotheeklabels van een geldverstrekker met behulp van de ID.
     * @param maatschappijId ID van de geldverstrekker
     * @return OK
     */
    hypotheeklabelsGeldverstrekkerMetIdOphalen(maatschappijId: string): Promise<ProductenBasisOutput> {
        let url_ = this.baseUrl + "/Maatschappijen/{maatschappijId}/Hypotheeklabels";
        if (maatschappijId === undefined || maatschappijId === null)
            throw new Error("The parameter 'maatschappijId' must be defined.");
        url_ = url_.replace("{maatschappijId}", encodeURIComponent("" + maatschappijId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheeklabelsGeldverstrekkerMetIdOphalen(_response);
        });
    }

    protected processHypotheeklabelsGeldverstrekkerMetIdOphalen(response: Response): Promise<ProductenBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenBasisOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenBasisOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductenBasisOutput>(null as any);
    }

    /**
     * Geeft gedetailleerde informatie over de beschikbare hypotheeklabels.
     * @return OK
     */
    hypotheeklabelsDetailsOphalen(): Promise<HypotheeklabelDetailsOutput> {
        let url_ = this.baseUrl + "/Hypotheeklabels/Details";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheeklabelsDetailsOphalen(_response);
        });
    }

    protected processHypotheeklabelsDetailsOphalen(response: Response): Promise<HypotheeklabelDetailsOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheeklabelDetailsOutput;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheeklabelDetailsOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HypotheeklabelDetailsOutput>(null as any);
    }

    /**
     * Geeft de beschikbare hypotheekvormen.
     * @return OK
     */
    hypotheekvormenOphalen(): Promise<HypotheekvormenBasisOutput> {
        let url_ = this.baseUrl + "/Hypotheekvormen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheekvormenOphalen(_response);
        });
    }

    protected processHypotheekvormenOphalen(response: Response): Promise<HypotheekvormenBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvormenBasisOutput;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvormenBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HypotheekvormenBasisOutput>(null as any);
    }

    /**
     * Geeft de beschikbare hypotheekvormen van een geldverstrekker met behulp van de code.
     * @param maatschappijCode Code van de geldverstrekker zoals deze in de Adviesbox producten-database is gedefinieerd
     * @return OK
     */
    hypotheekvormenGeldverstrekkerMetCodeOphalen(maatschappijCode: string): Promise<HypotheekvormenBasisOutput> {
        let url_ = this.baseUrl + "/MaatschappijCodes/{maatschappijCode}/Hypotheekvormen";
        if (maatschappijCode === undefined || maatschappijCode === null)
            throw new Error("The parameter 'maatschappijCode' must be defined.");
        url_ = url_.replace("{maatschappijCode}", encodeURIComponent("" + maatschappijCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheekvormenGeldverstrekkerMetCodeOphalen(_response);
        });
    }

    protected processHypotheekvormenGeldverstrekkerMetCodeOphalen(response: Response): Promise<HypotheekvormenBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvormenBasisOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvormenBasisOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvormenBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HypotheekvormenBasisOutput>(null as any);
    }

    /**
     * Geeft de beschikbare hypotheekvormen van een geldverstrekker met behulp van de ID.
     * @param maatschappijId ID van de geldverstrekker
     * @return OK
     */
    hypotheekvormenMetGeldverstrekkerIdOphalen(maatschappijId: string): Promise<HypotheekvormenBasisOutput> {
        let url_ = this.baseUrl + "/Maatschappijen/{maatschappijId}/Hypotheekvormen";
        if (maatschappijId === undefined || maatschappijId === null)
            throw new Error("The parameter 'maatschappijId' must be defined.");
        url_ = url_.replace("{maatschappijId}", encodeURIComponent("" + maatschappijId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheekvormenMetGeldverstrekkerIdOphalen(_response);
        });
    }

    protected processHypotheekvormenMetGeldverstrekkerIdOphalen(response: Response): Promise<HypotheekvormenBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvormenBasisOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvormenBasisOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvormenBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HypotheekvormenBasisOutput>(null as any);
    }

    /**
     * Geeft de beschikbare hypotheekvormen van een hypotheeklabel met behulp van de ID.
     * @param hypotheeklabelId ID van het hypotheeklabel
     * @return OK
     */
    hypotheekvormenMetHypotheeklabelIdOphalen(hypotheeklabelId: string): Promise<HypotheekvormenBasisOutput> {
        let url_ = this.baseUrl + "/Hypotheeklabels/{hypotheeklabelId}/Hypotheekvormen";
        if (hypotheeklabelId === undefined || hypotheeklabelId === null)
            throw new Error("The parameter 'hypotheeklabelId' must be defined.");
        url_ = url_.replace("{hypotheeklabelId}", encodeURIComponent("" + hypotheeklabelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheekvormenMetHypotheeklabelIdOphalen(_response);
        });
    }

    protected processHypotheekvormenMetHypotheeklabelIdOphalen(response: Response): Promise<HypotheekvormenBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvormenBasisOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvormenBasisOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvormenBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HypotheekvormenBasisOutput>(null as any);
    }

    /**
     * Geeft de beschikbare hypotheekvormen van een hypotheeklabel met behulp van de code.
     * @param maatschappijCode Code van de geldverstrekker zoals deze in de Adviesbox producten-database is gedefinieerd
     * @param hypotheeklabelCode Code van het hypotheeklabel zoals deze in de Adviesbox producten-database is gedefinieerd
     * @param inclGeenAankoop (optional) Indicatie dat hypotheekvormen waar geen aankoop mogelijk is teruggegeven moeten worden
     * @param maatschappijCodesDoorlopend (optional) 
     * @return OK
     */
    hypotheekvormenMetHypotheeklabelCodeOphalen(maatschappijCode: string, hypotheeklabelCode: number, inclGeenAankoop: boolean | null | undefined, maatschappijCodesDoorlopend: string | null | undefined): Promise<HypotheekvormenBasisOutput> {
        let url_ = this.baseUrl + "/MaatschappijCodes/{maatschappijCode}/HypotheeklabelCodes/{hypotheeklabelCode}/Hypotheekvormen?";
        if (maatschappijCode === undefined || maatschappijCode === null)
            throw new Error("The parameter 'maatschappijCode' must be defined.");
        url_ = url_.replace("{maatschappijCode}", encodeURIComponent("" + maatschappijCode));
        if (hypotheeklabelCode === undefined || hypotheeklabelCode === null)
            throw new Error("The parameter 'hypotheeklabelCode' must be defined.");
        url_ = url_.replace("{hypotheeklabelCode}", encodeURIComponent("" + hypotheeklabelCode));
        if (inclGeenAankoop !== undefined && inclGeenAankoop !== null)
            url_ += "inclGeenAankoop=" + encodeURIComponent("" + inclGeenAankoop) + "&";
        if (maatschappijCodesDoorlopend !== undefined && maatschappijCodesDoorlopend !== null)
            url_ += "maatschappijCodesDoorlopend=" + encodeURIComponent("" + maatschappijCodesDoorlopend) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheekvormenMetHypotheeklabelCodeOphalen(_response);
        });
    }

    protected processHypotheekvormenMetHypotheeklabelCodeOphalen(response: Response): Promise<HypotheekvormenBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvormenBasisOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvormenBasisOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HypotheekvormenBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HypotheekvormenBasisOutput>(null as any);
    }

    /**
     * Geeft de kenmerken van een hypotheekvorm met behulp van de code (maatschappij en product).
     * @param maatschappijCode Code van de geldverstrekker zoals deze in de Adviesbox producten-database is gedefinieerd
     * @param productCode Code van de hypotheekvorm zoals deze in de Adviesbox producten-database is gedefinieerd
     * @return OK
     */
    productkenmerkenHypotheekvormMetCodeOphalen(maatschappijCode: string, productCode: number): Promise<ProductkenmerkenOutput> {
        let url_ = this.baseUrl + "/MaatschappijCodes/{maatschappijCode}/Hypotheekvormen/{productCode}/Productkenmerken";
        if (maatschappijCode === undefined || maatschappijCode === null)
            throw new Error("The parameter 'maatschappijCode' must be defined.");
        url_ = url_.replace("{maatschappijCode}", encodeURIComponent("" + maatschappijCode));
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductkenmerkenHypotheekvormMetCodeOphalen(_response);
        });
    }

    protected processProductkenmerkenHypotheekvormMetCodeOphalen(response: Response): Promise<ProductkenmerkenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductkenmerkenOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductkenmerkenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductkenmerkenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductkenmerkenOutput>(null as any);
    }

    /**
     * Geeft de CodeDeelMij uit de HDN Keuzelijst CodeDeelMijType van een hypotheeklabel en hypotheekvorm.
     * @param maatschappijCode Code van de geldverstrekker zoals deze in de Adviesbox producten-database is gedefinieerd
     * @param hypotheeklabelCode Code van het hypotheeklabel zoals deze in de Adviesbox producten-database is gedefinieerd
     * @param productCode Code van de hypotheekvorm zoals deze in de Adviesbox producten-database is gedefinieerd
     * @return OK
     */
    codeDeelMijOphalen(maatschappijCode: string, hypotheeklabelCode: number, productCode: number): Promise<CodeDeelMijOutput> {
        let url_ = this.baseUrl + "/MaatschappijCodes/{maatschappijCode}/HypotheeklabelCodes/{hypotheeklabelCode}/Hypotheekvormen/{productCode}/CodeDeelMij";
        if (maatschappijCode === undefined || maatschappijCode === null)
            throw new Error("The parameter 'maatschappijCode' must be defined.");
        url_ = url_.replace("{maatschappijCode}", encodeURIComponent("" + maatschappijCode));
        if (hypotheeklabelCode === undefined || hypotheeklabelCode === null)
            throw new Error("The parameter 'hypotheeklabelCode' must be defined.");
        url_ = url_.replace("{hypotheeklabelCode}", encodeURIComponent("" + hypotheeklabelCode));
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCodeDeelMijOphalen(_response);
        });
    }

    protected processCodeDeelMijOphalen(response: Response): Promise<CodeDeelMijOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeDeelMijOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeDeelMijOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeDeelMijOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CodeDeelMijOutput>(null as any);
    }

    /**
     * Geeft de beschikbare kapitaalverzekeringen.
     * @return OK
     */
    kapitaalverzekeringenOphalen(): Promise<KapitaalverzekeringenOutput> {
        let url_ = this.baseUrl + "/Kapitaalverzekeringen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKapitaalverzekeringenOphalen(_response);
        });
    }

    protected processKapitaalverzekeringenOphalen(response: Response): Promise<KapitaalverzekeringenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KapitaalverzekeringenOutput;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KapitaalverzekeringenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KapitaalverzekeringenOutput>(null as any);
    }

    /**
     * Geeft de beschikbare kapitaalverzekeringen van een verzekeringsmaatschappij met behulp van de code.
     * @param maatschappijCode Code van de verzekeringsmaatschappij zoals deze in de Adviesbox producten-database is gedefinieerd
     * @return OK
     */
    kapitaalverzekeringenMetVerzekeringsmaatschappijCodeOphalen(maatschappijCode: string): Promise<KapitaalverzekeringenOutput> {
        let url_ = this.baseUrl + "/MaatschappijCodes/{maatschappijCode}/Kapitaalverzekeringen";
        if (maatschappijCode === undefined || maatschappijCode === null)
            throw new Error("The parameter 'maatschappijCode' must be defined.");
        url_ = url_.replace("{maatschappijCode}", encodeURIComponent("" + maatschappijCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKapitaalverzekeringenMetVerzekeringsmaatschappijCodeOphalen(_response);
        });
    }

    protected processKapitaalverzekeringenMetVerzekeringsmaatschappijCodeOphalen(response: Response): Promise<KapitaalverzekeringenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KapitaalverzekeringenOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KapitaalverzekeringenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KapitaalverzekeringenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KapitaalverzekeringenOutput>(null as any);
    }

    /**
     * Geeft de beschikbare kapitaalverzekeringen van een verzekeringsmaatschappij met behulp van de ID.
     * @param maatschappijId ID van de verzekeringsmaatschappij
     * @return OK
     */
    kapitaalverzekeringenMetVerzekeringsmaatschappijIdOphalen(maatschappijId: string): Promise<KapitaalverzekeringenOutput> {
        let url_ = this.baseUrl + "/Maatschappijen/{maatschappijId}/Kapitaalverzekeringen";
        if (maatschappijId === undefined || maatschappijId === null)
            throw new Error("The parameter 'maatschappijId' must be defined.");
        url_ = url_.replace("{maatschappijId}", encodeURIComponent("" + maatschappijId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKapitaalverzekeringenMetVerzekeringsmaatschappijIdOphalen(_response);
        });
    }

    protected processKapitaalverzekeringenMetVerzekeringsmaatschappijIdOphalen(response: Response): Promise<KapitaalverzekeringenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KapitaalverzekeringenOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KapitaalverzekeringenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KapitaalverzekeringenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KapitaalverzekeringenOutput>(null as any);
    }

    /**
     * Geeft de beschikbare kredietverstrekkers.
     * @return OK
     */
    kredietverstrekkersOphalen(): Promise<MaatschappijenDetailsOutput> {
        let url_ = this.baseUrl + "/Kredietverstrekkers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKredietverstrekkersOphalen(_response);
        });
    }

    protected processKredietverstrekkersOphalen(response: Response): Promise<MaatschappijenDetailsOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaatschappijenDetailsOutput;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaatschappijenDetailsOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaatschappijenDetailsOutput>(null as any);
    }

    /**
     * Geeft de beschikbare kredietvormen.
     * @return OK
     */
    kredietvormenOphalen(): Promise<KredietvormBasisOutput> {
        let url_ = this.baseUrl + "/Kredietvormen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKredietvormenOphalen(_response);
        });
    }

    protected processKredietvormenOphalen(response: Response): Promise<KredietvormBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KredietvormBasisOutput;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KredietvormBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KredietvormBasisOutput>(null as any);
    }

    /**
     * Geeft de beschikbare kredietvormen van een kredietverstrekker met behulp van de code.
     * @param maatschappijCode Code van de kredietverstrekker zoals deze in de Adviesbox producten-database is gedefinieerd
     * @return OK
     */
    kredietvormenMetKredietverstrekkerCodeOphalen(maatschappijCode: string): Promise<ProductenBasisOutput> {
        let url_ = this.baseUrl + "/MaatschappijCodes/{maatschappijCode}/Kredietvormen";
        if (maatschappijCode === undefined || maatschappijCode === null)
            throw new Error("The parameter 'maatschappijCode' must be defined.");
        url_ = url_.replace("{maatschappijCode}", encodeURIComponent("" + maatschappijCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKredietvormenMetKredietverstrekkerCodeOphalen(_response);
        });
    }

    protected processKredietvormenMetKredietverstrekkerCodeOphalen(response: Response): Promise<ProductenBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenBasisOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenBasisOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductenBasisOutput>(null as any);
    }

    /**
     * Geeft de beschikbare kredietvormen van een kredietverstrekker met behulp van de ID.
     * @param maatschappijId ID van de kredietverstrekker
     * @return OK
     */
    kredietvormenMetkredietverstrekkerIdOphalen(maatschappijId: string): Promise<ProductenBasisOutput> {
        let url_ = this.baseUrl + "/Maatschappijen/{maatschappijId}/Kredietvormen";
        if (maatschappijId === undefined || maatschappijId === null)
            throw new Error("The parameter 'maatschappijId' must be defined.");
        url_ = url_.replace("{maatschappijId}", encodeURIComponent("" + maatschappijId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKredietvormenMetkredietverstrekkerIdOphalen(_response);
        });
    }

    protected processKredietvormenMetkredietverstrekkerIdOphalen(response: Response): Promise<ProductenBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenBasisOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenBasisOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductenBasisOutput>(null as any);
    }

    /**
     * Geeft de beschikbare lijfrente-producten.
     * @return OK
     */
    lijfrenteProductenOphalen(): Promise<LijfrenteBasisOutput> {
        let url_ = this.baseUrl + "/Lijfrentes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLijfrenteProductenOphalen(_response);
        });
    }

    protected processLijfrenteProductenOphalen(response: Response): Promise<LijfrenteBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LijfrenteBasisOutput;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LijfrenteBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LijfrenteBasisOutput>(null as any);
    }

    /**
     * Geeft de beschikbare lijfrente-producten van een maatschappij met behulp van de code.
     * @param maatschappijCode Code van de maatschappij zoals deze in de Adviesbox producten-database is gedefinieerd
     * @return OK
     */
    lijfrenteProductenMetMaatschappijCodeOphalen(maatschappijCode: string): Promise<LijfrenteBasisOutput> {
        let url_ = this.baseUrl + "/MaatschappijCodes/{maatschappijCode}/Lijfrentes";
        if (maatschappijCode === undefined || maatschappijCode === null)
            throw new Error("The parameter 'maatschappijCode' must be defined.");
        url_ = url_.replace("{maatschappijCode}", encodeURIComponent("" + maatschappijCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLijfrenteProductenMetMaatschappijCodeOphalen(_response);
        });
    }

    protected processLijfrenteProductenMetMaatschappijCodeOphalen(response: Response): Promise<LijfrenteBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LijfrenteBasisOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LijfrenteBasisOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LijfrenteBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LijfrenteBasisOutput>(null as any);
    }

    /**
     * Geeft de beschikbare lijfrente-producten van een maatschappij met behulp van de ID.
     * @param maatschappijId ID van de maatschappij
     * @return OK
     */
    lijfrenteProductenMetMaatschappijIdOphalen(maatschappijId: string): Promise<LijfrenteBasisOutput> {
        let url_ = this.baseUrl + "/Maatschappijen/{maatschappijId}/Lijfrentes";
        if (maatschappijId === undefined || maatschappijId === null)
            throw new Error("The parameter 'maatschappijId' must be defined.");
        url_ = url_.replace("{maatschappijId}", encodeURIComponent("" + maatschappijId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLijfrenteProductenMetMaatschappijIdOphalen(_response);
        });
    }

    protected processLijfrenteProductenMetMaatschappijIdOphalen(response: Response): Promise<LijfrenteBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LijfrenteBasisOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LijfrenteBasisOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LijfrenteBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LijfrenteBasisOutput>(null as any);
    }

    /**
     * Geeft informatie over de beschikbare logo's
     * @return OK
     */
    logoInformatieOphalen(): Promise<LogoInformatieOutput> {
        let url_ = this.baseUrl + "/Logos/Beschikbaar";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogoInformatieOphalen(_response);
        });
    }

    protected processLogoInformatieOphalen(response: Response): Promise<LogoInformatieOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LogoInformatieOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LogoInformatieOutput>(null as any);
    }

    /**
     * Geeft het logo dat hoort bij de maatschappij in de gewenste breedte en hoogte.
     * @param maatschappij De identificatie van de maatschappij. Dit kan de unieke Id, de code of de korte omschrijving zijn
     * @param breedte (optional) De gevraagde breedte
     * @param hoogte (optional) De gevraagde hoogte
     * @return OK
     */
    logoOphalen(maatschappij: string, breedte: number | null | undefined, hoogte: number | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Logos/Logo/{maatschappij}?";
        if (maatschappij === undefined || maatschappij === null)
            throw new Error("The parameter 'maatschappij' must be defined.");
        url_ = url_.replace("{maatschappij}", encodeURIComponent("" + maatschappij));
        if (breedte !== undefined && breedte !== null)
            url_ += "breedte=" + encodeURIComponent("" + breedte) + "&";
        if (hoogte !== undefined && hoogte !== null)
            url_ += "hoogte=" + encodeURIComponent("" + hoogte) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogoOphalen(_response);
        });
    }

    protected processLogoOphalen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de beschikbare ORV's.
     * @return OK
     */
    orvsOphalen(): Promise<OrvBasisOutput> {
        let url_ = this.baseUrl + "/Orv";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrvsOphalen(_response);
        });
    }

    protected processOrvsOphalen(response: Response): Promise<OrvBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrvBasisOutput;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrvBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrvBasisOutput>(null as any);
    }

    /**
     * Geeft detail-informatie van de beschikbare ORV's met filter.
     * @param uitkeringType (optional) Soort uitkering waarop gefilterd moet worden.
     * @param premieverloop (optional) Soort premieverloop waarop gefilterd moet worden.
     * @param reservewaarde (optional) Indicatie dat premiereserve / reservewaarde van toepassing is.
     * @return OK
     */
    orvDetailsOphalen(uitkeringType: UitkeringType | null | undefined, premieverloop: Premieverloop | null | undefined, reservewaarde: boolean | null | undefined): Promise<OrvDetailsOutput> {
        let url_ = this.baseUrl + "/Orv/Details?";
        if (uitkeringType !== undefined && uitkeringType !== null)
            url_ += "uitkeringType=" + encodeURIComponent("" + uitkeringType) + "&";
        if (premieverloop !== undefined && premieverloop !== null)
            url_ += "premieverloop=" + encodeURIComponent("" + premieverloop) + "&";
        if (reservewaarde !== undefined && reservewaarde !== null)
            url_ += "reservewaarde=" + encodeURIComponent("" + reservewaarde) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrvDetailsOphalen(_response);
        });
    }

    protected processOrvDetailsOphalen(response: Response): Promise<OrvDetailsOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrvDetailsOutput;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrvDetailsOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrvDetailsOutput>(null as any);
    }

    /**
     * Geeft de beschikbare ORV's van een verzekeringsmaatschappij met behulp van de code.
     * @param maatschappijCode Code van de verzekeringsmaatschappij zoals deze in de Adviesbox producten-database is gedefinieerd
     * @return OK
     */
    orvsMetVerzekeringsmaatschappijCodeOphalen(maatschappijCode: string): Promise<OrvBasisOutput> {
        let url_ = this.baseUrl + "/MaatschappijCodes/{maatschappijCode}/Orv";
        if (maatschappijCode === undefined || maatschappijCode === null)
            throw new Error("The parameter 'maatschappijCode' must be defined.");
        url_ = url_.replace("{maatschappijCode}", encodeURIComponent("" + maatschappijCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrvsMetVerzekeringsmaatschappijCodeOphalen(_response);
        });
    }

    protected processOrvsMetVerzekeringsmaatschappijCodeOphalen(response: Response): Promise<OrvBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrvBasisOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrvBasisOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrvBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrvBasisOutput>(null as any);
    }

    /**
     * Geeft de beschikbare ORV's van een verzekeringsmaatschappij met behulp van de ID.
     * @param maatschappijId ID van de verzekeringsmaatschappij
     * @return OK
     */
    orvsMetVerzekeringsmaatschappijIdOphalen(maatschappijId: string): Promise<OrvBasisOutput> {
        let url_ = this.baseUrl + "/Maatschappijen/{maatschappijId}/Orv";
        if (maatschappijId === undefined || maatschappijId === null)
            throw new Error("The parameter 'maatschappijId' must be defined.");
        url_ = url_.replace("{maatschappijId}", encodeURIComponent("" + maatschappijId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrvsMetVerzekeringsmaatschappijIdOphalen(_response);
        });
    }

    protected processOrvsMetVerzekeringsmaatschappijIdOphalen(response: Response): Promise<OrvBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrvBasisOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrvBasisOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrvBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrvBasisOutput>(null as any);
    }

    /**
     * Geeft de kenmerken van een ORV met behulp van de code (maatschappij en product).
     * @param maatschappijCode Code van de verzekeringsmaatschappij zoals deze in de Adviesbox producten-database is gedefinieerd
     * @param productCode Code van de ORV zoals deze in de Adviesbox producten-database is gedefinieerd
     * @return OK
     */
    orvProductkenmerkenOphalen(maatschappijCode: string, productCode: number): Promise<ProductkenmerkenOutput> {
        let url_ = this.baseUrl + "/MaatschappijCodes/{maatschappijCode}/Orv/{productCode}/Productkenmerken";
        if (maatschappijCode === undefined || maatschappijCode === null)
            throw new Error("The parameter 'maatschappijCode' must be defined.");
        url_ = url_.replace("{maatschappijCode}", encodeURIComponent("" + maatschappijCode));
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrvProductkenmerkenOphalen(_response);
        });
    }

    protected processOrvProductkenmerkenOphalen(response: Response): Promise<ProductkenmerkenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductkenmerkenOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductkenmerkenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductkenmerkenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductkenmerkenOutput>(null as any);
    }

    /**
     * Geeft de beschikbare serviceproviders.
     * @return OK
     */
    serviceprovidersOphalen(): Promise<MaatschappijenDetailsOutput> {
        let url_ = this.baseUrl + "/Serviceproviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processServiceprovidersOphalen(_response);
        });
    }

    protected processServiceprovidersOphalen(response: Response): Promise<MaatschappijenDetailsOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaatschappijenDetailsOutput;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaatschappijenDetailsOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaatschappijenDetailsOutput>(null as any);
    }

    /**
     * Geeft de beschikbare taxatiebureaus.
     * @return OK
     */
    taxatiebureausOphalen(): Promise<MaatschappijenDetailsOutput> {
        let url_ = this.baseUrl + "/Taxatiebureaus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTaxatiebureausOphalen(_response);
        });
    }

    protected processTaxatiebureausOphalen(response: Response): Promise<MaatschappijenDetailsOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaatschappijenDetailsOutput;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaatschappijenDetailsOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaatschappijenDetailsOutput>(null as any);
    }

    /**
     * Geeft de beschikbare taxatievormen.
     * @return OK
     */
    taxatievormenOphalen(): Promise<TaxatievormBasisOutput> {
        let url_ = this.baseUrl + "/Taxatievormen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTaxatievormenOphalen(_response);
        });
    }

    protected processTaxatievormenOphalen(response: Response): Promise<TaxatievormBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatievormBasisOutput;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatievormBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaxatievormBasisOutput>(null as any);
    }

    /**
     * Geeft de beschikbare taxatievormen van een taxatiebureau met behulp van de code.
     * @param maatschappijCode Code van het taxatiebureau zoals deze in de Adviesbox producten-database is gedefinieerd
     * @return OK
     */
    taxatievormenMetCodeOphalen(maatschappijCode: string): Promise<TaxatievormBasisOutput> {
        let url_ = this.baseUrl + "/MaatschappijCodes/{maatschappijCode}/Taxatievormen";
        if (maatschappijCode === undefined || maatschappijCode === null)
            throw new Error("The parameter 'maatschappijCode' must be defined.");
        url_ = url_.replace("{maatschappijCode}", encodeURIComponent("" + maatschappijCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTaxatievormenMetCodeOphalen(_response);
        });
    }

    protected processTaxatievormenMetCodeOphalen(response: Response): Promise<TaxatievormBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatievormBasisOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatievormBasisOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatievormBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaxatievormBasisOutput>(null as any);
    }

    /**
     * Geeft de beschikbare taxatievormen van een taxatiebureau met behulp van de ID.
     * @param maatschappijId ID van het taxatiebureau
     * @return OK
     */
    taxatievormenMetIdOphalen(maatschappijId: string): Promise<TaxatievormBasisOutput> {
        let url_ = this.baseUrl + "/Maatschappijen/{maatschappijId}/Taxatievormen";
        if (maatschappijId === undefined || maatschappijId === null)
            throw new Error("The parameter 'maatschappijId' must be defined.");
        url_ = url_.replace("{maatschappijId}", encodeURIComponent("" + maatschappijId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTaxatievormenMetIdOphalen(_response);
        });
    }

    protected processTaxatievormenMetIdOphalen(response: Response): Promise<TaxatievormBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatievormBasisOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatievormBasisOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatievormBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaxatievormBasisOutput>(null as any);
    }

    /**
     * Geeft de kenmerken van een taxatie met behulp van een maatschappijcode en de vorm (product) code
     * @param maatschappijCode Maatschappijcode
     * @param productCode productCode
     * @return OK
     */
    productkenmerken_taxatie_ophalen(maatschappijCode: string, productCode: number): Promise<ProductkenmerkenOutput> {
        let url_ = this.baseUrl + "/Maatschappijcodes/{maatschappijCode}/Productcodes/{productCode}/Taxatievormen/Productkenmerken";
        if (maatschappijCode === undefined || maatschappijCode === null)
            throw new Error("The parameter 'maatschappijCode' must be defined.");
        url_ = url_.replace("{maatschappijCode}", encodeURIComponent("" + maatschappijCode));
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductkenmerken_taxatie_ophalen(_response);
        });
    }

    protected processProductkenmerken_taxatie_ophalen(response: Response): Promise<ProductkenmerkenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductkenmerkenOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductkenmerkenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductkenmerkenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductkenmerkenOutput>(null as any);
    }

    /**
     * Geeft de beschikbare uitvaartverzekeringen.
     * @return OK
     */
    uitvaartverzekeringenOphalen(): Promise<ProductenBasisOutput> {
        let url_ = this.baseUrl + "/Uitvaartverzekeringen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUitvaartverzekeringenOphalen(_response);
        });
    }

    protected processUitvaartverzekeringenOphalen(response: Response): Promise<ProductenBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenBasisOutput;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductenBasisOutput>(null as any);
    }

    /**
     * Geeft de beschikbare uitvaartverzekeringen van een verzekeringsmaatschappij met behulp van de code.
     * @param maatschappijCode Code van de verzekeringsmaatschappij zoals deze in de Adviesbox producten-database is gedefinieerd
     * @return OK
     */
    uitvaartverzekeringenMetVerzekeringsmaatschappijCodeOphalen(maatschappijCode: string): Promise<ProductenBasisOutput> {
        let url_ = this.baseUrl + "/MaatschappijCodes/{maatschappijCode}/Uitvaartverzekeringen";
        if (maatschappijCode === undefined || maatschappijCode === null)
            throw new Error("The parameter 'maatschappijCode' must be defined.");
        url_ = url_.replace("{maatschappijCode}", encodeURIComponent("" + maatschappijCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUitvaartverzekeringenMetVerzekeringsmaatschappijCodeOphalen(_response);
        });
    }

    protected processUitvaartverzekeringenMetVerzekeringsmaatschappijCodeOphalen(response: Response): Promise<ProductenBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenBasisOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenBasisOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductenBasisOutput>(null as any);
    }

    /**
     * Geeft de beschikbare uitvaartverzekeringen van een verzekeringsmaatschappij met behulp van de ID.
     * @param maatschappijId ID van de verzekeringsmaatschappij
     * @return OK
     */
    uitvaartverzekeringenMetVerzekeringsmaatschappijIdOphalen(maatschappijId: string): Promise<ProductenBasisOutput> {
        let url_ = this.baseUrl + "/Maatschappijen/{maatschappijId}/Uitvaartverzekeringen";
        if (maatschappijId === undefined || maatschappijId === null)
            throw new Error("The parameter 'maatschappijId' must be defined.");
        url_ = url_.replace("{maatschappijId}", encodeURIComponent("" + maatschappijId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUitvaartverzekeringenMetVerzekeringsmaatschappijIdOphalen(_response);
        });
    }

    protected processUitvaartverzekeringenMetVerzekeringsmaatschappijIdOphalen(response: Response): Promise<ProductenBasisOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenBasisOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenBasisOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenBasisOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductenBasisOutput>(null as any);
    }

    /**
     * Geeft de beschikbare vermogensbeheerders.
     * @return OK
     */
    vermogensbeheerders_ophalen(): Promise<MaatschappijenDetailsOutput> {
        let url_ = this.baseUrl + "/Vermogensbeheerders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVermogensbeheerders_ophalen(_response);
        });
    }

    protected processVermogensbeheerders_ophalen(response: Response): Promise<MaatschappijenDetailsOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaatschappijenDetailsOutput;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaatschappijenDetailsOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaatschappijenDetailsOutput>(null as any);
    }

    /**
     * Geeft de beschikbare vermogensproducten.
     * @return OK
     */
    vermogensproductenOphalen(): Promise<VermogensvormenOutput> {
        let url_ = this.baseUrl + "/Vermogensproducten";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVermogensproductenOphalen(_response);
        });
    }

    protected processVermogensproductenOphalen(response: Response): Promise<VermogensvormenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VermogensvormenOutput;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VermogensvormenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VermogensvormenOutput>(null as any);
    }

    /**
     * Geeft de beschikbare vermogensproducten van een vermogensbeheerder met behulp van de code.
     * @param maatschappijCode Code van de vermogensbeheerder zoals deze in de Adviesbox producten-database is gedefinieerd
     * @return OK
     */
    vermogensproductenMetVermogensbeheerderCodeOphalen(maatschappijCode: string): Promise<VermogensvormenOutput> {
        let url_ = this.baseUrl + "/MaatschappijCodes/{maatschappijCode}/Vermogensproducten";
        if (maatschappijCode === undefined || maatschappijCode === null)
            throw new Error("The parameter 'maatschappijCode' must be defined.");
        url_ = url_.replace("{maatschappijCode}", encodeURIComponent("" + maatschappijCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVermogensproductenMetVermogensbeheerderCodeOphalen(_response);
        });
    }

    protected processVermogensproductenMetVermogensbeheerderCodeOphalen(response: Response): Promise<VermogensvormenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VermogensvormenOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VermogensvormenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VermogensvormenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VermogensvormenOutput>(null as any);
    }

    /**
     * Geeft de beschikbare vermogensproducten van een vermogensbeheerder met behulp van de ID.
     * @param maatschappijId ID van de vermogensbeheerder
     * @return OK
     */
    vermogensproductenMetVermogensbeheerderIdOphalen(maatschappijId: string): Promise<VermogensvormenOutput> {
        let url_ = this.baseUrl + "/Maatschappijen/{maatschappijId}/Vermogensproducten";
        if (maatschappijId === undefined || maatschappijId === null)
            throw new Error("The parameter 'maatschappijId' must be defined.");
        url_ = url_.replace("{maatschappijId}", encodeURIComponent("" + maatschappijId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVermogensproductenMetVermogensbeheerderIdOphalen(_response);
        });
    }

    protected processVermogensproductenMetVermogensbeheerderIdOphalen(response: Response): Promise<VermogensvormenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VermogensvormenOutput;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VermogensvormenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VermogensvormenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VermogensvormenOutput>(null as any);
    }

    /**
     * @return OK
     */
    getVersionInfo(): Promise<VersionInfo> {
        let url_ = this.baseUrl + "/VersionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVersionInfo(_response);
        });
    }

    protected processGetVersionInfo(response: Response): Promise<VersionInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VersionInfo;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BadRequestResult;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VersionInfo>(null as any);
    }

    /**
     * @return OK
     */
    getFoutcodes(): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/VersionInfo/FoutCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFoutcodes(_response);
        });
    }

    protected processGetFoutcodes(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * Geeft de beschikbare verzekeringsmaatschappijen.
     * @return OK
     */
    verzekeringsmaatschappijenOphalen(): Promise<MaatschappijenDetailsOutput> {
        let url_ = this.baseUrl + "/Verzekeringsmaatschappijen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerzekeringsmaatschappijenOphalen(_response);
        });
    }

    protected processVerzekeringsmaatschappijenOphalen(response: Response): Promise<MaatschappijenDetailsOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaatschappijenDetailsOutput;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaatschappijenDetailsOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaatschappijenDetailsOutput>(null as any);
    }
}

/** AflossingsVormType Geen = 0, Annuïteit = 1, Lineair = 2, Levensverzekering = 3, Spaar = 4, Aflosvrij = 5, Krediet = 9, Belegging = 10, Hybride = 11, UnitLinked = 12, Spaarrekening = 13, AnnuïteitUitgesteld = 20, AnnuïteitBlok = 21, KredietNoPay = 22 */
export enum AflossingsVormType {
    Geen = "Geen",
    Annuïteit = "Annuïteit",
    Lineair = "Lineair",
    Levensverzekering = "Levensverzekering",
    Spaar = "Spaar",
    Aflosvrij = "Aflosvrij",
    Krediet = "Krediet",
    Belegging = "Belegging",
    Hybride = "Hybride",
    UnitLinked = "UnitLinked",
    Spaarrekening = "Spaarrekening",
    AnnuïteitUitgesteld = "AnnuïteitUitgesteld",
    AnnuïteitBlok = "AnnuïteitBlok",
    KredietNoPay = "KredietNoPay",
}

export interface AovBasis {
    hdnLxCode: string | null;
    code: number;
    productnaam: string | null;
    maatschappijId: string | null;
    maatschappijNaamLang: string | null;
    hdnNummer: number | null;
    hdnOntvangerCode: string | null;
    renteboxMaatschappijCode: string | null;
    opmerkingen: string | null;
    maatschappijCode: string | null;
    maatschappijNaamKort: string | null;
}

export interface AovBasisOutput {
    aovProducten: { [key: string]: AovBasis; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface BadRequestResult {
    statusCode: number;
}

export interface CodeDeelMijOutput {
    readonly codeDeelMij: string | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface Fonds {
    code: number;
    mijCode: string | null;
    fondsnaam: string | null;
    voorbeeldrendementPercentage: number | null;
    historischRendementPercentage: number | null;
    aankoopkostenPercentage: number | null;
    verkoopkostenPercentage: number | null;
    beheerskostenPercentage: number | null;
}

export interface FondsenOutput {
    fondsen: { [key: string]: Fonds; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface HypotheeklabelDetails {
    opslagZelfstandigenPercentage: number | null;
    administratiekostenBedrag: number | null;
    renteAutoUpdate: boolean | null;
    renteUpdateDirect: boolean | null;
    renteWaardeopbouw: boolean | null;
    renteAlleenAanvStorting: boolean | null;
    geenKortingBijRenteAfspraak: RenteAfspraakType | null;
    startersleningToegestaan: boolean;
    restschuldNhg: boolean;
    restschuldGhf: boolean;
    hypotheekopties: Hypotheekoptie[] | null;
    maatschappijRenteboxCode: string | null;
    hdnCode: string | null;
    code: number;
    productnaam: string | null;
    maatschappijId: string | null;
    maatschappijNaamLang: string | null;
    hdnNummer: number | null;
    hdnOntvangerCode: string | null;
    renteboxMaatschappijCode: string | null;
    opmerkingen: string | null;
    maatschappijCode: string | null;
    maatschappijNaamKort: string | null;
}

export interface HypotheeklabelDetailsOutput {
    producten: { [key: string]: HypotheeklabelDetails; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface HypotheeklabelMetHypotheekopties {
    hypotheekopties: Hypotheekoptie[] | null;
    code: number;
    productnaam: string | null;
    maatschappijId: string | null;
    maatschappijNaamLang: string | null;
    hdnNummer: number | null;
    hdnOntvangerCode: string | null;
    renteboxMaatschappijCode: string | null;
    opmerkingen: string | null;
    maatschappijCode: string | null;
    maatschappijNaamKort: string | null;
}

export interface HypotheeklabelMetHypotheekoptiesOutput {
    producten: { [key: string]: HypotheeklabelMetHypotheekopties; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface Hypotheekoptie {
    code: number;
    omschrijving: string | null;
    toelichting: string | null;
    rentekortingPercentage: number | null;
    hdnCode: string | null;
    default: boolean;
    optieGroep: number | null;
    verplicht: boolean;
    ondernemerstarief: boolean;
}

export interface HypotheekvormBasis {
    aflossingsvorm: AflossingsVormType;
    restschuldFinanciering: boolean;
    renteboxCode: number;
    heeftLooptijdInMaanden: boolean;
    geenAankoop: boolean;
    hdnCode: string | null;
    geenRenteOpties: boolean;
    datumActief: string;
    datumInactief: string;
    code: number;
    productnaam: string | null;
    maatschappijId: string | null;
    maatschappijNaamLang: string | null;
    hdnNummer: number | null;
    hdnOntvangerCode: string | null;
    renteboxMaatschappijCode: string | null;
    opmerkingen: string | null;
    maatschappijCode: string | null;
    maatschappijNaamKort: string | null;
}

export interface HypotheekvormenBasisOutput {
    hypotheekvormen: { [key: string]: HypotheekvormBasis; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface Kapitaalverzekering {
    soortProduct: SoortKapitaalverzekeringOptions;
    code: number;
    productnaam: string | null;
    maatschappijId: string | null;
    maatschappijNaamLang: string | null;
    hdnNummer: number | null;
    hdnOntvangerCode: string | null;
    renteboxMaatschappijCode: string | null;
    opmerkingen: string | null;
    maatschappijCode: string | null;
    maatschappijNaamKort: string | null;
}

export interface KapitaalverzekeringenOutput {
    readonly producten: { [key: string]: Kapitaalverzekering; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface KredietvormBasis {
    soortKredietProduct: SoortKredietProductOptions;
    code: number;
    productnaam: string | null;
    maatschappijId: string | null;
    maatschappijNaamLang: string | null;
    hdnNummer: number | null;
    hdnOntvangerCode: string | null;
    renteboxMaatschappijCode: string | null;
    opmerkingen: string | null;
    maatschappijCode: string | null;
    maatschappijNaamKort: string | null;
}

export interface KredietvormBasisOutput {
    kredietvormen: { [key: string]: KredietvormBasis; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface LijfrenteBasis {
    soortLijfrenteProduct: SoortLijfrenteProductOptions;
    code: number;
    productnaam: string | null;
    maatschappijId: string | null;
    maatschappijNaamLang: string | null;
    hdnNummer: number | null;
    hdnOntvangerCode: string | null;
    renteboxMaatschappijCode: string | null;
    opmerkingen: string | null;
    maatschappijCode: string | null;
    maatschappijNaamKort: string | null;
}

export interface LijfrenteBasisOutput {
    lijfrenteProducten: { [key: string]: LijfrenteBasis; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface LogoFormaat {
    breedte: number;
    hoogte: number;
}

export interface LogoInformatie {
    maatschappijId: string;
    maatschappijcode: string | null;
    formaten: LogoFormaat[] | null;
}

export interface LogoInformatieOutput {
    informatie: LogoInformatie[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface MaatschappijDetails {
    maatschappijId: string | null;
    maatschappijNaamLang: string | null;
    hdnNummer: number | null;
    hdnOntvangerCode: string | null;
    renteboxMaatschappijCode: string | null;
    opmerkingen: string | null;
    maatschappijCode: string | null;
    maatschappijNaamKort: string | null;
}

export interface MaatschappijenDetailsOutput {
    maatschappijen: { [key: string]: MaatschappijDetails; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface OrvBasis {
    productvorm: UitkeringTypeOptions;
    hdnLxCode: string | null;
    code: number;
    productnaam: string | null;
    maatschappijId: string | null;
    maatschappijNaamLang: string | null;
    hdnNummer: number | null;
    hdnOntvangerCode: string | null;
    renteboxMaatschappijCode: string | null;
    opmerkingen: string | null;
    maatschappijCode: string | null;
    maatschappijNaamKort: string | null;
}

export interface OrvBasisOutput {
    orvProducten: { [key: string]: OrvBasis; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface OrvDetails {
    codeRekenkern: number | null;
    premieverloopVariabel: boolean | null;
    premieverloopGelijkblijvend: boolean | null;
    reservewaarde: boolean | null;
    productvorm: UitkeringTypeOptions;
    hdnLxCode: string | null;
    code: number;
    productnaam: string | null;
    maatschappijId: string | null;
    maatschappijNaamLang: string | null;
    hdnNummer: number | null;
    hdnOntvangerCode: string | null;
    renteboxMaatschappijCode: string | null;
    opmerkingen: string | null;
    maatschappijCode: string | null;
    maatschappijNaamKort: string | null;
}

export interface OrvDetailsOutput {
    orvProducten: { [key: string]: OrvDetails; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** PremieverloopOptions Gelijkblijvend = 0, Variabel = 1 */
export enum PremieverloopOptions {
    Gelijkblijvend = "Gelijkblijvend",
    Variabel = "Variabel",
}

export interface ProductBasis {
    code: number;
    productnaam: string | null;
    maatschappijId: string | null;
    maatschappijNaamLang: string | null;
    hdnNummer: number | null;
    hdnOntvangerCode: string | null;
    renteboxMaatschappijCode: string | null;
    opmerkingen: string | null;
    maatschappijCode: string | null;
    maatschappijNaamKort: string | null;
}

export interface ProductenBasisOutput {
    producten: { [key: string]: ProductBasis; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface ProductkenmerkCategorie {
    categorie: ProductkenmerkCategorieOptions;
    productkenmerken: { [key: string]: any; };
}

/** ProductkenmerkCategorieOptions Product = 1, Persoonkeuze = 2, Dekking = 3, Premie = 4, Verpanding = 5, Lening = 6, Fiscaal = 7, Leningdeel = 8, Validaties = 9, Aanvraag = 10, Leninggegevens = 11, Kapitaalopbouw = 12, FiscaleRegeling = 13, GekoppeldProduct = 14, HdnAanvraag = 15, Opmerking = 16 */
export enum ProductkenmerkCategorieOptions {
    Product = "Product",
    Persoonkeuze = "Persoonkeuze",
    Dekking = "Dekking",
    Premie = "Premie",
    Verpanding = "Verpanding",
    Lening = "Lening",
    Fiscaal = "Fiscaal",
    Leningdeel = "Leningdeel",
    Validaties = "Validaties",
    Aanvraag = "Aanvraag",
    Leninggegevens = "Leninggegevens",
    Kapitaalopbouw = "Kapitaalopbouw",
    FiscaleRegeling = "FiscaleRegeling",
    GekoppeldProduct = "GekoppeldProduct",
    HdnAanvraag = "HdnAanvraag",
    Opmerking = "Opmerking",
}

export interface ProductkenmerkenOutput {
    productkenmerkCategorieen: ProductkenmerkCategorie[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** RenteAfspraakType Geen = 0, Rentevast = 1, Rentedempend = 2, ContinuVariabel = 3, Correctie = 4, PlafondClick = 5, Samengesteld = 6, Orientatie = 9 */
export enum RenteAfspraakType {
    Geen = "Geen",
    Rentevast = "Rentevast",
    Rentedempend = "Rentedempend",
    ContinuVariabel = "ContinuVariabel",
    Correctie = "Correctie",
    PlafondClick = "PlafondClick",
    Samengesteld = "Samengesteld",
    Orientatie = "Orientatie",
}

/** SoortKapitaalverzekeringOptions Lijfrenteverzekering = 1, UniversalLifePremie = 2, Product = 99 */
export enum SoortKapitaalverzekeringOptions {
    Lijfrenteverzekering = "Lijfrenteverzekering",
    UniversalLifePremie = "UniversalLifePremie",
    Product = "Product",
}

/** SoortKredietProductOptions AflopendKrediet = 1, DoorlopendKrediet = 2, Studielening = 3, Restschuldlening = 4, Werkgeverslening = 5, Privatelease = 6 */
export enum SoortKredietProductOptions {
    AflopendKrediet = "AflopendKrediet",
    DoorlopendKrediet = "DoorlopendKrediet",
    Studielening = "Studielening",
    Restschuldlening = "Restschuldlening",
    Werkgeverslening = "Werkgeverslening",
    Privatelease = "Privatelease",
}

/** SoortLijfrenteProductOptions Lijfrenteverzekering = 1, BancaireLijfrente = 2 */
export enum SoortLijfrenteProductOptions {
    Lijfrenteverzekering = "Lijfrenteverzekering",
    BancaireLijfrente = "BancaireLijfrente",
}

/** SoortTaxatieProductOptions Oversluiting = 1, AanVerkoopBeslissing = 2, BouwkundigeKeuring = 3, Combinatie = 4, Anders = 5 */
export enum SoortTaxatieProductOptions {
    Oversluiting = "Oversluiting",
    AanVerkoopBeslissing = "AanVerkoopBeslissing",
    BouwkundigeKeuring = "BouwkundigeKeuring",
    Combinatie = "Combinatie",
    Anders = "Anders",
}

/** SoortVermogensproductOptions Beleggingsdepot = 1, Spaarrekening = 2, Effectenlease = 3, Betaalrekening = 4, Product = 99 */
export enum SoortVermogensproductOptions {
    Beleggingsdepot = "Beleggingsdepot",
    Spaarrekening = "Spaarrekening",
    Effectenlease = "Effectenlease",
    Betaalrekening = "Betaalrekening",
    Product = "Product",
}

export interface TaxatievormBasis {
    soortTaxatieProduct: SoortTaxatieProductOptions;
    code: number;
    productnaam: string | null;
    maatschappijId: string | null;
    maatschappijNaamLang: string | null;
    hdnNummer: number | null;
    hdnOntvangerCode: string | null;
    renteboxMaatschappijCode: string | null;
    opmerkingen: string | null;
    maatschappijCode: string | null;
    maatschappijNaamKort: string | null;
}

export interface TaxatievormBasisOutput {
    taxatievormen: { [key: string]: TaxatievormBasis; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** UitkeringTypeOptions LineairDalend = 1, AnnuitairDalend = 2, Gelijkblijvend = 3, AnwHiaatVerzekering = 4 */
export enum UitkeringTypeOptions {
    LineairDalend = "LineairDalend",
    AnnuitairDalend = "AnnuitairDalend",
    Gelijkblijvend = "Gelijkblijvend",
    AnwHiaatVerzekering = "AnwHiaatVerzekering",
}

export interface ValidationResultModel {
    code: string | null;
    target: string | null;
    message: string | null;
}

export interface Vermogensvorm {
    soortProduct: SoortVermogensproductOptions;
    code: number;
    productnaam: string | null;
    maatschappijId: string | null;
    maatschappijNaamLang: string | null;
    hdnNummer: number | null;
    hdnOntvangerCode: string | null;
    renteboxMaatschappijCode: string | null;
    opmerkingen: string | null;
    maatschappijCode: string | null;
    maatschappijNaamKort: string | null;
}

export interface VermogensvormenOutput {
    readonly producten: { [key: string]: Vermogensvorm; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface VersionInfo {
    naam: string | null;
    versie: string | null;
    auteur: string | null;
    copyright: string | null;
    opstartDatumTijd: string | null;
}

/** Soort uitkering waarop gefilterd moet worden. */
export enum UitkeringType {
    LineairDalend = "LineairDalend",
    AnnuitairDalend = "AnnuitairDalend",
    Gelijkblijvend = "Gelijkblijvend",
    AnwHiaatVerzekering = "AnwHiaatVerzekering",
}

/** Soort premieverloop waarop gefilterd moet worden. */
export enum Premieverloop {
    Gelijkblijvend = "Gelijkblijvend",
    Variabel = "Variabel",
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}